/* eslint-disable @typescript-eslint/camelcase */
export type FormFieldConfiguration = {
  enabled: boolean;
  required: boolean;
  label?: string;
};
export const ADDRESS_FIELDS = [
  'addressTypeID',
  'street',
  'address2',
  'postalCode',
  'city',
  'state',
  'country',
] as const;
const PERSON_FIELDS = [
  'firstName',
  'lastName',
  'personTitleID',
  'gender',
  'jobTitleID',
  'customerCardNumber',
  'euCustomerType',
  'groupID',
  'homeStoreID',
  'email',
  'phone',
  'fax',
  'mobile',
  'birthday',
  ...ADDRESS_FIELDS,
  'code',
  'notes',
  'emailOptOut',
  'taxExempt',
  'doNotSell',
] as const;
const COMPANY_FIELDS = [
  'companyName',
  'vatNumber',
  'customerCardNumber',
  'euCustomerType',
  'groupID',
  'homeStoreID',
  'email',
  'phone',
  'fax',
  'mobile',
  ...ADDRESS_FIELDS,
  'code',
  'notes',
  'emailOptOut',
  'taxExempt',
  'doNotSell',
] as const;
type FormFields = {
  PERSON: Record<typeof PERSON_FIELDS[number], FormFieldConfiguration>;
  COMPANY: Record<typeof COMPANY_FIELDS[number], FormFieldConfiguration>;
};
export type CustomerType = 'PERSON' | 'COMPANY';
type CustomerFormConfiguration = {
  allowedCustomerTypes: CustomerType | '';
  formFields: FormFields;
};
export type CustomerPOSConfiguration = {
  customer_form_configuration: CustomerFormConfiguration;
};
export const CUSTOMER_TYPES = {
  PERSON: 'PERSON',
  COMPANY: 'COMPANY',
} as const;
export const DEFAULT_CUSTOMER_CREATION_CONFIG_VALUE: CustomerFormConfiguration = {
  allowedCustomerTypes: '',
  formFields: {
    [CUSTOMER_TYPES.PERSON]: {
      firstName: { enabled: true, required: true },
      lastName: { enabled: true, required: true },
      personTitleID: { enabled: true, required: false },
      gender: { enabled: true, required: false },
      jobTitleID: { enabled: true, required: false },
      customerCardNumber: { enabled: true, required: false },
      euCustomerType: { enabled: true, required: false },
      groupID: { enabled: true, required: false },
      homeStoreID: { enabled: true, required: false },
      email: { enabled: true, required: false },
      phone: { enabled: true, required: false },
      fax: { enabled: true, required: false },
      mobile: { enabled: true, required: false },
      birthday: { enabled: true, required: false },
      addressTypeID: { enabled: true, required: false },
      street: { enabled: true, required: false },
      address2: { enabled: true, required: false },
      postalCode: { enabled: true, required: false },
      city: { enabled: true, required: false },
      state: { enabled: true, required: false },
      country: { enabled: true, required: false },
      code: { enabled: true, required: false },
      notes: { enabled: true, required: false },
      emailOptOut: { enabled: true, required: false },
      taxExempt: { enabled: true, required: false },
      doNotSell: { enabled: true, required: false },
    },
    [CUSTOMER_TYPES.COMPANY]: {
      companyName: { enabled: true, required: true },
      vatNumber: { enabled: true, required: false },
      customerCardNumber: { enabled: true, required: false },
      euCustomerType: { enabled: true, required: false },
      groupID: { enabled: true, required: false },
      homeStoreID: { enabled: true, required: false },
      email: { enabled: true, required: false },
      phone: { enabled: true, required: false },
      fax: { enabled: true, required: false },
      mobile: { enabled: true, required: false },
      addressTypeID: { enabled: true, required: false },
      street: { enabled: true, required: false },
      address2: { enabled: true, required: false },
      postalCode: { enabled: true, required: false },
      city: { enabled: true, required: false },
      state: { enabled: true, required: false },
      country: { enabled: true, required: false },
      code: { enabled: true, required: false },
      notes: { enabled: true, required: false },
      emailOptOut: { enabled: true, required: false },
      taxExempt: { enabled: true, required: false },
      doNotSell: { enabled: true, required: false },
    },
  },
};
export const DEFAULT_CUSTOMER_POS_CONFIGURATION: CustomerPOSConfiguration = {
  customer_form_configuration: DEFAULT_CUSTOMER_CREATION_CONFIG_VALUE,
};
export const FORM_FIELDS = {
  [CUSTOMER_TYPES.PERSON]: PERSON_FIELDS,
  [CUSTOMER_TYPES.COMPANY]: COMPANY_FIELDS,
} as const;
export const API_REQUIRED_FIELDS = ['firstName', 'lastName', 'companyName'];
